/* import __COLOCATED_TEMPLATE__ from './old-version.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();